
import Vue from 'vue';
import MISC_DATA from '@/store/modules/MiscDataModule';

import SectionHeading from '@/components/general/utils/SectionHeading.vue';
import { IMediaLogos } from '~/types/misc_data';

export default Vue.extend({
	name: 'KnownFrom',

	components: { SectionHeading },

	data() {
		return {};
	},

	computed: {
		MISC_DATA: () => MISC_DATA,

		isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		},

		mediaLogos(): IMediaLogos[][] {
			return this.MISC_DATA.data_per_bu.media_logos;
		}
	}
});
